import {FormControl, FormGroup} from '@angular/forms';
import {BaseAbstract} from './BaseAbstract';

export class MatchingPassword extends BaseAbstract {

    private keyError: string;

    private passwordControl: FormControl;

    private confirmPasswordControl: FormControl;

    // ########################################

    constructor(
        keyError: string,
        passwordControlKey: FormControl,
        confirmPasswordControlKey: FormControl
    ) {
        super();

        this.keyError = keyError;
        this.passwordControl = passwordControlKey;
        this.confirmPasswordControl = confirmPasswordControlKey;
    }

    // ########################################

    protected validate() {
        return (form: FormGroup): { [key: string]: any } => {

            if (this.confirmPasswordControl.value === this.passwordControl.value) {

                if (this.confirmPasswordControl.errors && this.confirmPasswordControl.errors[this.keyError]) {
                    delete this.confirmPasswordControl.errors[this.keyError];
                }

                if (this.confirmPasswordControl.errors && Object.keys(this.confirmPasswordControl.errors).length !== 0) {
                    this.confirmPasswordControl.setErrors({...this.confirmPasswordControl.errors});
                } else {
                    this.confirmPasswordControl.setErrors(null);
                }

                return null;
            } else {
                this.confirmPasswordControl.setErrors(
                    {...this.confirmPasswordControl.errors,
                        [this.keyError]: true}
                        );

                return {
                    [this.keyError]: true
                };
            }
        };
    }

    // ########################################
}
